import React from 'react';

const InvalidRoute = () => {
  return <div color={{ color: '#fff' }}>InvalidRoute</div>;
};

export default InvalidRoute;
